import axios from 'axios';

import { fdApiUse } from '../apiUtils';
import { GoogleGeocodeResponse } from '../general/general.types';
import {
  AddressI18nFormScheme,
  DeliveryLocation,
  DeliveryLocationForms,
  GetDeliveryLocationFormsQueryParams,
  PostDeliveryLocationFormRequestPayload,
  PostDeliveryLocationFormResponse,
  PostFormatGoogleAddressQueryParams,
  PostRequestPhoneLoginCodeCallRequestPayload,
  PostRequestPhoneLoginCodeSmsRequestPayload,
  PostSetEmailAddressRequestPayload,
  PutReceivePromotionsRequestPayload,
  ReceivePromotionSetting,
} from './user.types';

// #region get requests
export const getDeliveryLocationForms = (
  queryParams: GetDeliveryLocationFormsQueryParams,
): Promise<DeliveryLocation[]> =>
  fdApiUse(
    axios.get('/map/DeliveryLocationForms', {
      params: queryParams,
    }),
  ).then((data: DeliveryLocationForms) => data.DeliveryLocations);
// #endregion

// #region post requests
export const postDeliveryLocationForm = (
  requestPayload: PostDeliveryLocationFormRequestPayload,
): Promise<PostDeliveryLocationFormResponse> =>
  fdApiUse(axios.post('/map/DeliveryLocationForm', requestPayload)).then(
    (data: PostDeliveryLocationFormResponse) => data,
  );

export const postFormatGoogleAddress = (
  queryParams: PostFormatGoogleAddressQueryParams,
  requestPayload: GoogleGeocodeResponse,
): Promise<AddressI18nFormScheme> =>
  fdApiUse(
    axios.post('/address/formatGoogleAddress', requestPayload, {
      params: queryParams,
    }),
  ).then((data: AddressI18nFormScheme) => data);

export const postRequestPhoneLoginCodeSms = (
  requestPayload:
    | PostRequestPhoneLoginCodeSmsRequestPayload
    | PostRequestPhoneLoginCodeCallRequestPayload,
  hCaptchaToken?: string,
): Promise<number> => {
  const hCaptchaResponse = hCaptchaToken
    ? {
        'h-captcha-response': hCaptchaToken,
      }
    : undefined;
  const commonHeaders = {
    ...axios.defaults.headers.common,
    ...hCaptchaResponse,
  };
  delete commonHeaders['X-Flipdish-Token'];

  return fdApiUse(
    axios.post('/Account/RequestPhoneLoginCodeSms', requestPayload, {
      headers: {
        common: commonHeaders,
      },
      withCredentials: false,
    }),
  ).then((data: number) => data);
};

export const postSetEmailAddress = (
  requestPayload: PostSetEmailAddressRequestPayload,
): Promise<void> =>
  fdApiUse(
    axios.post('/Account/SetEmailAddress', requestPayload, {
      withCredentials: true,
    }),
  );

export const postAccountLogOff = (): Promise<void> =>
  fdApiUse(axios.post('/Account/LogOff'));
// #endregion

// #region put requests
export const putOverAlcoholAgeLimit = (): Promise<void> =>
  fdApiUse(axios.put('/Account/OverAlcoholAgeLimit/true'));

export const putReceivePromotions = (
  requestPayload: PutReceivePromotionsRequestPayload,
): Promise<ReceivePromotionSetting> =>
  fdApiUse(axios.put('/Account/SmsPromotionsEnabledFlag', requestPayload));
// #endregion
